/** Admin: per-(org, user, capability) configuration. */
import { apiDelete, apiGet, apiPut } from '../client.js';
import type { UserCapabilityConfig } from '../types.js';

export function getUserCapabilityConfig(
  organizationId: string,
  platformUserId: string,
  capabilityId: string,
): Promise<UserCapabilityConfig> {
  return apiGet<UserCapabilityConfig>(
    `/api/v1/admin/organizations/${organizationId}/users/${platformUserId}/capability-configs/${encodeURIComponent(capabilityId)}`,
  );
}

export function setUserCapabilityConfig(
  organizationId: string,
  platformUserId: string,
  capabilityId: string,
  config: Record<string, unknown>,
): Promise<UserCapabilityConfig> {
  return apiPut<UserCapabilityConfig>(
    `/api/v1/admin/organizations/${organizationId}/users/${platformUserId}/capability-configs/${encodeURIComponent(capabilityId)}`,
    { config },
  );
}

export function deleteUserCapabilityConfig(
  organizationId: string,
  platformUserId: string,
  capabilityId: string,
): Promise<void> {
  return apiDelete<void>(
    `/api/v1/admin/organizations/${organizationId}/users/${platformUserId}/capability-configs/${encodeURIComponent(capabilityId)}`,
  );
}
